const GQL_UPDATE_BADGE = `
mutation UpdateBadge($studentId: ID!, $badgeId: ID!, $awarded: Boolean, $awarder: String, $seen: Boolean) {
  updateStudentBadge(input: {studentId: $studentId, badgeId: $badgeId, awarded: $awarded, awarder: $awarder, seen: $seen}) {
    awarded
    awardedAt
    awarder
    badgeTypeId
    createdAt
    createdAtDate
    description
    id
    recipient
    rewardLevelId
    schoolId
    seen
    studentId
    classId
  }
}

`;

export default GQL_UPDATE_BADGE;